const VEHICLE_RESOURCE_TYPE_PREFIX = 'VehicleAgilox';
const MODEL_VERSION_SUFFIX = /v\d+$/i;

// The new backend types a vehicle by its model without the version, so ONE and ONEV2 are both One
export function getVehicleResourceType(model: string): string {
	const base = model.replace(MODEL_VERSION_SUFFIX, '');
	return VEHICLE_RESOURCE_TYPE_PREFIX + base.charAt(0).toUpperCase() + base.slice(1).toLowerCase();
}
